import crudHandlers from './_crud'
import { convertToArrayObject } from 'utils'

export default (state, action) => {
	const { type } = action
	switch (type) {
		case 'LOAD_CUSTOM_INSTANCES':
			return {
				...state,
				entities: convertToArrayObject(action.payload),
			}
			case 'GET_CUSTOM_CATALOG_INSTANCE_BY_QUESTION':
				return {
					...state,
					entities: convertToArrayObject(action.payload),
				}
		default:
			state = crudHandlers(state, action, 'custom_catalog_instance')

			return state
	}
}
